import { RepaymentType } from '@/shared/enums/repayment.enum';

export const MONTHS = [
  {
    label: 'January',
    value: 'january',
  },
  {
    label: 'February',
    value: 'february',
  },
  {
    label: 'March',
    value: 'march',
  },
  {
    label: 'April',
    value: 'april',
  },
  {
    label: 'May',
    value: 'may',
  },
  {
    label: 'June',
    value: 'june',
  },
  {
    label: 'July',
    value: 'july',
  },
  {
    label: 'August',
    value: 'august',
  },
  {
    label: 'September',
    value: 'september',
  },
  {
    label: 'October',
    value: 'october',
  },
  {
    label: 'November',
    value: 'november',
  },
  {
    label: 'December',
    value: 'december',
  },
];

export const YEARS = Array.from({ length: 60 }, (_, i) => {
  const year = new Date().getFullYear() - i;
  return { label: year.toString(), value: year.toString() };
}).reverse();

export const AGREE_OPTIONS = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const PROPERTY_LOCATION_TYPE_OPTIONS = [
  {
    label: 'Australian',
    value: 'australian',
  },
  {
    label: 'Overseas',
    value: 'overseas',
  },
];

export const OPTIONAL_AGREE_OPTIONS = [
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Maybe',
    value: 'maybe',
  },
];

export const FREQUENCY_OPTIONS = [
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Annually',
    value: 'annually',
  },
  {
    label: 'Fortnightly',
    value: 'fortnightly',
  },
];

export const RATE_TYPE_OPTIONS = [
  { label: 'Fixed', value: 'fixed_rate' },
  { label: 'Variable', value: 'variable_rate' },
  { label: 'Fixed & Variable Rate', value: 'fixed_and_variable_rate' },
];

export const PROPERTY_OWNER_TYPE_OPTIONS = [
  {
    label: 'I own this',
    value: 'own',
  },
  {
    label: 'Co-applicant owns this',
    value: 'coapplicant_own',
  },
  {
    label: 'Jointly owned with co-applicant',
    value: 'jointly_own',
  },
  {
    label: 'Owned with other(s)',
    value: 'own_with_other',
  },
  {
    label: 'Trust / Company',
    value: 'trust_or_company',
  },
];

export const PROPERTY_USE_TYPE_OPTIONS = [
  {
    label: 'Primary residence',
    value: 'primary_residence',
  },
  {
    label: 'Investment (rented)',
    value: 'rented',
  },
  {
    label: 'Investment (airbnb/short-term lease)',
    value: 'short_term_lease',
  },
  {
    label: 'Investment (untenanted)',
    value: 'untenanted',
  },
  {
    label: 'Commercial property',
    value: 'commercial',
  },
];

export const OVERSEAS_PROPERTY_PURPOSE_OPTIONS = [
  {
    label: 'Owner Occupier Home',
    value: 'owner_occupier_home',
  },
  {
    label: 'Investment Property',
    value: 'investment_property',
  },
];

export const STATES_OPTIONS = [
  {
    label: 'New South Wales (NSW)',
    value: 'nsw',
  },
  {
    label: 'Victoria (VIC) ',
    value: 'vic',
  },
  {
    label: 'Queensland (QLD)',
    value: 'qld',
  },
  {
    label: 'Western Australia (WA)',
    value: 'wa',
  },
  {
    label: 'Southern Australia (SA)',
    value: 'sa',
  },
  {
    label: 'Tasmania (TAS)',
    value: 'tas',
  },
  {
    label: 'Northern Territory (NT)',
    value: 'nt',
  },
  {
    label: 'Australian Capital Territory (ACT)',
    value: 'act',
  },
];

export const EMPLOYMENT_OPTIONS = [
  {
    label: 'Employee',
    value: 'employee',
  },
  {
    label: 'Self-Employed (Sole trader / Contractor)',
    value: 'self_employed_trader_or_contractor',
  },
  {
    label: 'Self-employed (Company)',
    value: 'self_employed_company',
  },
  {
    label: 'Unemployed / Home Duties',
    value: 'unemployed',
  },
];

export const LOAN_TYPE_OPTIONS = [
  {
    label: 'Personal Loan',
    value: 'personal_loan',
  },
  {
    label: 'Car Loan',
    value: 'car_loan',
  },
  {
    label: 'Tax Loan',
    value: 'tax_loan',
  },
  {
    label: 'Margin Loan',
    value: 'margin_loan',
  },
  {
    label: 'Student Loan',
    value: 'student_loan',
  },
];

export const RELATIONSHIP_OPTIONS = [
  {
    label: 'My Spouse',
    value: 'my_spouse',
  },
  {
    label: 'My Partner (Unmarried)',
    value: 'my_partner',
  },
  {
    label: 'My Mother/Father',
    value: 'my_mother_or_father',
  },
  {
    label: 'My Brother/Sister/Relative',
    value: 'my_brother_sister_relative',
  },
  {
    label: 'My friend',
    value: 'friend',
  },
  {
    label: 'My Child',
    value: 'child ',
  },
];

export const CITIZENSHIP_OPTIONS = [
  {
    value: 'australian_citizen',
    label: 'Australian Citizen',
  },
  {
    value: 'australian_pr_visa',
    label: 'Australian PR Visa',
  },
  {
    value: 'australian_tr_visa',
    label: 'Australian TR Visa',
  },
  {
    value: 'newzeland_citizen',
    label: 'New Zealand Citizen',
  },
  {
    value: 'foreign_national',
    label: 'Foreign National',
  },
];

export const GENDER_OPTIONS = [
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const MARITIAL_STATUS_OPTIONS = [
  {
    label: 'Single',
    value: 'single',
  },
  {
    label: 'Married',
    value: 'married',
  },
  {
    label: 'De-facto',
    value: 'defacto',
  },
  {
    label: 'Divorced',
    value: 'divorced',
  },
  {
    label: 'Widowed',
    value: 'widowed',
  },
];

export const RESIDENTIAL_STATUS_OPTIONS = [
  {
    label: 'I’m renting',
    value: 'renting',
  },
  {
    label: 'I live in my own place',
    value: 'live_own_place',
  },
  {
    label: 'I’m rent free/ boarding (parent)',
    value: 'rent_free_or_boarding_parent',
  },
  {
    label: 'I live rent free/ boarding (spouse)',
    value: 'rent_free_or_boarding_spouse',
  },
  {
    label: 'I live rent free/ boarding (friend)',
    value: 'rent_free_or_boarding_friend',
  },

  {
    label: 'live rent free/ boarding (employer provides)',
    value: 'rent_free_or_boarding_employer',
  },
  {
    label: 'Other (Provide Specification)',
    value: 'other',
  },
];

export const WHERE_DID_YOU_HEAR_ABOUT_US_OPTIONS = [
  {
    label: 'Google',
    value: 'google',
  },
  {
    label: 'Google Ads',
    value: 'google_ads',
  },
  {
    label: 'Blog Articles',
    value: 'blog_articles',
  },
  {
    label: 'Word of Mouth',
    value: 'word_of_mouth',
  },
  {
    label: 'Facebook',
    value: 'facebook',
  },
  {
    label: 'Australian Associations',
    value: 'australian_associations',
  },
  {
    label: 'Professional Referral (Agent/Fin. Planners)',
    value: 'professional_referral_agent_fin_planners',
  },
  {
    label: 'Social Media',
    value: 'social_media',
  },
  {
    label: 'Webinars',
    value: 'webinars',
  },
  {
    label: 'Existing Client',
    value: 'existing_client',
  },
];

export const OVERSEAS_PROPERTY_USE_OPTIONS = [
  {
    label: 'Owner Occupier Home',
    value: 'owner_occupier_home',
  },
  {
    label: 'Investment Property',
    value: 'investment_property',
  },
];

export const LOAN_PURPOSE_OPTIONS = [
  {
    label: 'INV Property',
    value: 'investment_property',
    titleLabel: 'Investment Property',
  },
  {
    label: 'INV Property Purchase',
    value: 'investment_property_purchase',
    titleLabel: 'Property Purchase',
  },
  {
    label: 'INV Property Pre-approval',
    value: 'investment_property_pre_approval',
    titleLabel: 'Pre-approval',
  },
  {
    label: 'INV Vacant Land Pre-approval',
    value: 'investment_vacant_land_pre_approval',
    titleLabel: 'Pre-approval',
  },
  {
    label: 'INV House & Land Pre-approval',
    value: 'investment_house_and_land_pre_approval',
    titleLabel: 'Pre-approval',
  },
  {
    label: 'INV Property Refinance',
    value: 'investment_property_refinance',
    titleLabel: 'Refinance',
  },
  {
    label: 'INV Property Refinance + Cashout',
    value: 'investment_property_refinance_cashout',
    titleLabel: 'Refinance + Cashout',
  },
  {
    label: 'INV Property Cashout Only',
    value: 'investment_property_cashoutonly',
    titleLabel: 'Cashout Only',
  },
  {
    label: 'INV Vacant Land',
    value: 'investment_vacant_land',
    titleLabel: 'Vacant Land',
  },
  {
    label: 'INV House & Land Construction',
    value: 'investment_house_and_land_construction',
    titleLabel: 'Construction',
  },
  {
    label: 'Owner occupier (OO)',
    value: 'owner_occupier_property_purchase',
    titleLabel: 'Owner Occupier',
  },
  {
    label: 'INV initially, then OO',
    value: 'inv_initially_then_oo',
    titleLabel: 'Investment initially, then Owner Occupier',
  },
  {
    label: 'Holiday Home',
    value: 'holiday_home',
    titleLabel: 'Holiday Home',
  },
  {
    label: 'Owner-occupier Property Pre-approval',
    value: 'owner_occupier_property_pre_approval',
    titleLabel: 'Pre-approval',
  },
  {
    label: 'Owner-occupier Property Refinance',
    value: 'owner_occupier_property_refinance',
    titleLabel: 'Refinance',
  },
  {
    label: 'Owner-occupier Property Refinance + Equity Release',
    value: 'owner_occupier_property_refinance_equity_release',
    titleLabel: 'Refinance + Equity Release',
  },
  {
    label: 'Owner-occupier Property Equity Cash-out',
    value: 'owner_occupier_property_equity_cash_out',
    titleLabel: 'Equity Cash-out',
  },
  {
    label: 'Owner-occupier Vacant Land',
    value: 'owner_occupier_vacant_land',
    titleLabel: 'Vacant Land',
  },
  {
    label: 'Owner-Occupier House & Land Construction',
    value: 'owner_occupier_house_and_land_construction',
    titleLabel: 'Construction',
  },
];

export const CASH_OUT_INVOLVED_OPTIONS = [
  {
    value: 'assist_with_the_property_purchase_transaction',
    label: 'Assist with the property purchase transaction',
  },
  {
    value: 'non_structural_renovation_of_existing_properties',
    label: 'Non-structural renovation of existing properties',
  },
  {
    value: 'to_cash_buy_future_australian_property_outright',
    label: 'To cash buy future Australian property outright',
  },
  { value: 'other', label: 'Other' },
];

export const CARD_CURRENCY_LIST = [
  { value: 'HKD', label: 'HKD' },
  { value: 'SGD', label: 'SGD' },
  { value: 'USD', label: 'USD' },
  { value: 'GBP', label: 'GBP' },
  { value: 'JPY', label: 'JPY' },
  { value: 'AED', label: 'AED' },
  { value: 'AUD', label: 'AUD' },
];

export const REPAYMENT_OPTIONS = [
  { label: 'Interest Only', value: 'interest_only' },
  { label: 'Principal & Interest', value: 'p_and_l_repayments' },
];

export const INTEREST_TYPE_OPTIONS = [
  { label: 'Variable', value: 'variable' },
  { label: '1YR Fixed', value: '1yr_fixed' },
  { label: '2YR Fixed', value: '2yr_fixed' },
  { label: '3YR Fixed', value: '3yr_fixed' },
  { label: '4YR Fixed', value: '4yr_fixed' },
  { label: '5YR Fixed', value: '5yr_fixed' },
];

export const REPAYMENT_TYPE = [
  { label: 'Interest Only', value: RepaymentType.P_AND_I },
  { label: 'Principal & Interest', value: RepaymentType.I_O },
];

export const LOAN_STRUCTURE_OPTIONS = [
  { value: 'standalone', label: 'standalone' },
  { value: 'cross_collateralised', label: 'cross-collateralised' },
  { value: 'multiple_securities', label: 'multiple securities' },
];

export const PURCHASING_UNDER_OPTIONS = [
  {
    label: 'I’m buying in personal name (Sole borrower)',
    value: 'solo_borrower',
    icon: 'man',
  },
  {
    label: 'I’m buying in personal names (Joint borrowers)',
    value: 'joint_borrower',
    icon: 'jointProperty',
  },
  {
    label: 'I’m buying under a Trust',
    value: 'trust',
    icon: 'trust',
  },
  {
    label: 'I’m buying under a non trading company',
    value: 'non_trading_company',
    icon: 'nonTrading',
  },
];
export const PROPERTY_TYPE_OPTIONS = [
  {
    label: 'House',
    value: 'house',
    icon: 'house',
  },
  {
    label: 'Build/Construction Only',
    value: 'build_or_construction',
    icon: 'building',
  },
  {
    label: 'Apartment Unit',
    value: 'apartment',
    icon: 'apartment',
  },
  {
    label: 'Land & House Turnkey (1 contract)',
    value: 'land_house_turnkey',
    icon: 'man',
  },
  {
    label: 'Off-The-Plan Apartment',
    value: 'off_plan_apartment',
    icon: 'offApartment',
  },
  {
    label: 'Land & House Split (2 contracts)',
    value: 'land_house_split',
    icon: 'jointProperty',
  },
  {
    label: 'Land Only',
    value: 'land_only',
    icon: 'map',
  },
];
export const PROPERTY_TIMEFRAME_OPTIONS = [
  {
    label: 'Immediately. Already signed contract',
    value: 'immediately',
  },
  {
    label: 'ASAP: Found a property',
    value: 'asap',
  },
  {
    label: 'Within 6 Months',
    value: 'within_6_months',
  },
  {
    label: 'More than 6 Months',
    value: 'more_than_6_months',
  },
  {
    label: 'Not Sure Yet',
    value: 'not_sure',
  },
];

export const LOAN_PRICING_OPTIONS = [
  { value: 'yes_applicable', label: 'Yes, applicable' },
  { value: 'not_yet_requested', label: 'Not yet requested' },
  { value: 'na', label: 'N/A' },
];

export const VALUATION_OPTIONS = [
  { value: 'na_aip', label: 'N/A, AIP' },
  { value: 'completed', label: 'Completed' },
  { value: 'ordered', label: 'Ordered' },
  { value: 'to_be_ordered', label: 'To Be Ordered' },
];

export const PRIVATE_EDUCATION_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  {
    value: 'yes_covered_by_employer',
    label: 'Yes, but covered by employer',
  },
];

export const SALUTATION_OPTIONS = [
  {
    label: 'Mr.',
    value: 'Mr.',
  },
  {
    label: 'Ms.',
    value: 'Ms.',
  },
  {
    label: 'Miss.',
    value: 'Miss.',
  },
  {
    label: 'Mrs.',
    value: 'Mrs.',
  },
  {
    label: 'Dr.',
    value: 'Dr.',
  },
  {
    label: 'Prof.',
    value: 'Prof.',
  },
  {
    label: 'Rev.',
    value: 'Rev.',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const LOAN_STATUS_OPTIONS = [
  { label: 'Open', value: 'open' },
  { label: 'Closed', value: 'closed' },
];
export const LENDER_OPTIONS = [
  { value: 'aaa_finance', label: 'AAA Finance' },
  { value: 'anz_bank', label: 'ANZ Bank' },
  { value: 'bankwest', label: 'Bankwest' },
  { value: 'bc_invest', label: 'BC Invest' },
  { value: 'boq', label: 'BOQ' },
  { value: 'brighten', label: 'Brighten' },
  { value: 'cba', label: 'CBA' },
  { value: 'great_southern_bank', label: 'Great Southern Bank' },
  { value: 'heritage', label: 'Heritage' },
  { value: 'ing', label: 'Ing' },
  { value: 'la_trobe', label: 'LaTrobe' },
  { value: 'macquarie_bank', label: 'Macquarie Bank' },
  { value: 'ma_money', label: 'MA Money' },
  { value: 'mezy', label: 'MEZY' },
  { value: 'nab', label: 'NAB' },
  { value: 'qudos', label: 'Qudos' },
  { value: 'st_george_bank', label: 'St. George Bank' },
  { value: 'suncorp', label: 'Suncorp' },
  { value: 'westpac', label: 'Westpac' },
  { value: 'granite', label: 'Granite' },
  { value: 'firstmac', label: 'Firstmac' },
  { value: 'resimac', label: 'Resimac' },
  { value: 'blue_stone', label: 'Blue Stone' },
];

// Lenders with a "sheet" to attach in the credit-analyst Lender Sheet Data
// drawer. Hand-picked subset of LENDER_OPTIONS for now — add more values here
// as they come on board.
export const SERVICING_LENDERS = LENDER_OPTIONS.filter((lender) =>
  ['hsbc', 'bankwest'].includes(lender.value),
);

// Mirrors the backend `DocumentType` enum
// (brokercopilot-backend/src/modules/documents/enums/document.enum.ts).
// Keep in sync with that enum — these values are the source of truth for a
// document's `docType`.
export const DOC_TYPE_OPTIONS = [
  { label: 'Personal Loan Statement', value: 'PERSONAL_LOAN_STATEMENT' },
  { label: 'Bank Statement', value: 'BANK_STATEMENT' },
  { label: 'Credit Card Statement', value: 'CREDIT_CARD_STATEMENT' },
  { label: 'Employment Document', value: 'EMPLOYMENT_DOCUMENT' },
  { label: 'Employment RSU Document', value: 'EMPLOYMENT_RSU_DOCUMENT' },
  { label: 'FTC Document', value: 'FTC_DOCUMENT' },
  { label: 'Identity Document', value: 'IDENTITY' },
  { label: 'Mortgage Statement', value: 'MORTGAGE_STATEMENT' },
  { label: 'Payslip / Pay Stub', value: 'PAYSLIP' },
  { label: 'Tenancy Agreement', value: 'TENANCY_AGREEMENT' },
  { label: 'Rental Income Statement', value: 'RENTAL_INCOME_STATEMENT' },
  { label: 'Tax Document', value: 'TAX_DOCUMENT' },
  { label: 'Credit Report', value: 'CREDIT_REPORT' },
  { label: 'Property Purchase Document', value: 'PROPERTY_PURCHASE_DOCUMENT' },
  { label: 'Property Outgoings', value: 'PROPERTY_OUTGOINGS' },
  { label: 'Property Report', value: 'PROPERTY_REPORT' },
  { label: 'Other', value: 'OTHER' },
];
